
var onBoardRoutes = [
  { redirect: true, path: "/", pathTo: "/registration", name: "Home" }
];
export default onBoardRoutes;
